import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
/* -------------------------------------------------------------------------
 * Module-level side effects — run BEFORE React renders.
 * Critical for LCP: preconnect + preload the hero image as early as
 * possible so the browser can fetch it in parallel with the JS bundle.
 * ------------------------------------------------------------------------- */
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/ebnaz7hiPmdc8TiCBWyoEd/Diseno-sin-titulo-_54_.webp';
if (typeof document !== 'undefined') {
  // Preconnect to the image CDN — saves ~100-300ms of DNS/TLS on cold loads.
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  // Preload the LCP image so the browser starts fetching immediately,
  // in parallel with parsing JS/CSS.
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = HERO_IMAGE;
  // @ts-ignore - fetchPriority is a valid HTMLLinkElement attribute
  preload.fetchPriority = 'high';
  document.head.appendChild(preload);
}
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1181648490064668');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1181648490064668&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
export function App() {
  useEffect(() => {
    // Defer Meta Pixel aggressively — only load it when the browser is
    // truly idle so it never competes with LCP or interaction readiness.
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 5000
      });
    } else {
      setTimeout(loadMetaPixel, 3500);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}